/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus202,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus400,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus401,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus500,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusMutationRequest,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusMutationResponse,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusPathParams,
} from "../../types/courseRegistrationAssociatedCompanyDocumentApprovalController/PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus.ts";
import { updateAssociatedCompanyDocumentStatusRequestViewModelSchema } from "../updateAssociatedCompanyDocumentStatusRequestViewModelSchema.ts";
import { updateAssociatedCompanyDocumentStatusResponseViewModelSchema } from "../updateAssociatedCompanyDocumentStatusResponseViewModelSchema.ts";

export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
    associatedCompanyDocumentId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus202Schema =
  z.lazy(
    () => updateAssociatedCompanyDocumentStatusResponseViewModelSchema,
  ) as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus500>;

export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusMutationRequestSchema =
  z.lazy(
    () => updateAssociatedCompanyDocumentStatusRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusMutationRequest>;

export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusMutationResponseSchema =
  z.lazy(
    () =>
      putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatus202Schema,
  ) as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidDocumentAssociatedcompanydocumentidStatusMutationResponse>;
